// i18n
import "./locales/i18n";

// highlight
import "./utils/highlight";

// scroll bar
import "simplebar/src/simplebar.css";

// lightbox
import "react-image-lightbox/style.css";

import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
// material
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import LocalizationProvider from "@material-ui/lab/LocalizationProvider";
import heLocale from "date-fns/locale/he";
// redux
import { store, persistor } from "./redux/store";
// contexts
import { SettingsProvider } from "./contexts/SettingsContext";
import { CollapseDrawerProvider } from "./contexts/CollapseDrawerContext";
// components
import LoadingScreen from "./components/LoadingScreen";

// Check our docs
// https://docs-minimals.vercel.app/authentication/ts-version

// import { AuthProvider } from './contexts/JWTContext';
// import { AuthProvider } from './contexts/AwsCognitoContext';
// import { AuthProvider } from './contexts/Auth0Context';
import { AuthProvider } from "./contexts/FirebaseContext";

//
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { installChunkLoadErrorHandler } from "./utils/chunkLoadErrorHandler";

// ----------------------------------------------------------------------

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
}

installChunkLoadErrorHandler();

ReactDOM.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        {/*
          The prop is `locale` in @material-ui/lab@5.0.0-alpha.43 — there is no
          `adapterLocale` (that name arrives in a much later @mui/x-date-pickers).
          The previous `adapterLocale="ru"` was therefore silently dropped, the
          adapter was constructed with `locale: undefined`, and every picker in
          the app fell back to date-fns' default en-US: American MM/dd/yyyy dates
          and a 12-hour AM/PM cycle in a Hebrew RTL dashboard.

          `dateFormats.keyboardDate` is pinned rather than left to the locale on
          purpose. Hebrew's own short-date pattern is `d.M.y` ("27.7.2026"), but
          every picker in the app that sets an explicit inputFormat uses
          `dd/MM/yyyy`; pinning it keeps the two MobileDateRangePickers that set
          none (common/DateRangeFilter + signatures/DocumentsList) consistent
          with the rest instead of switching them to a third format.
        */}
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          locale={heLocale}
          dateFormats={{ keyboardDate: "dd/MM/yyyy" }}
        >
          <SettingsProvider>
            <CollapseDrawerProvider>
              <BrowserRouter>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </BrowserRouter>
            </CollapseDrawerProvider>
          </SettingsProvider>
        </LocalizationProvider>
      </PersistGate>
    </ReduxProvider>
  </HelmetProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
